import React from "react";
import "../css/delivery.scss";
import PolicyPage from "./PolicyPage";

function Delivery() {
  return (
    <PolicyPage title="Shipping Policy">
      <p><em>Last updated: October 16, 2026</em></p>
      <h2>Shipping Charge</h2>
      <p>A flat shipping charge of <strong>USD 9.99</strong> applies to every order and is shown in the cart and checkout totals.</p>

      <h2>Order Preparation</h2>
      <p>Most orders are prepared within 2–5 business days. A style requiring additional finishing may take longer; if so, we will email you before dispatch. Business days exclude weekends and applicable public holidays.</p>

      <h2>Delivery Estimates</h2>
      <p>Estimated transit is usually 5–15 business days after dispatch, depending on destination and carrier conditions. Tracking is emailed when available. Estimates are not guaranteed delivery dates.</p>

      <h2>Delivery Destinations</h2>
      <p>Available countries are shown at checkout. We do not accept orders for destinations subject to applicable trade or payment restrictions. If a destination becomes unavailable after purchase, we will cancel and refund the affected order.</p>

      <h2>Tracking and Split Shipments</h2>
      <p>Tracking is emailed when provided by the carrier. An order may arrive in more than one parcel; if so, each available tracking reference will be supplied and the USD 9.99 order shipping charge will not be duplicated.</p>

      <h2>Address Accuracy</h2>
      <p>Please check the recipient name, email, street address, city and postal code before payment. Contact <a href="mailto:core@danecay.shop">core@danecay.shop</a> immediately if a correction is needed. We cannot guarantee changes after dispatch.</p>

      <h2>Delays, Loss or Damage</h2>
      <p>If tracking has not updated for seven business days, or the parcel arrives damaged, email us with the order number and clear photos where relevant. We will investigate with the carrier and explain the available replacement or refund options.</p>

      <h2>Delivered but Not Found</h2>
      <p>If tracking shows delivery but you cannot locate the parcel, check the delivery area, household members and any carrier notice, then contact the carrier and <a href="mailto:core@danecay.shop">core@danecay.shop</a> promptly. We will assist with a carrier investigation; the outcome will account for the available delivery evidence and mandatory consumer rights.</p>

      <h2>Customs and Events Outside Control</h2>
      <p>International parcels may be delayed or charged by customs. See the Customs, Duties &amp; Taxes Policy. Severe weather, transport disruption, government action and similar events can affect estimates, but do not remove any remedy required by law.</p>
    </PolicyPage>
  );
}

export default Delivery;
